"use client";
import { useEffect } from "react";

export default function ClearSessionOnReload() {
  useEffect(() => {
    // Check if page was refreshed
    const wasRefreshed = sessionStorage.getItem("page_refreshed");
    if (wasRefreshed === "true") {
      sessionStorage.removeItem("filter_param");
      sessionStorage.removeItem("page_refreshed");
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem("page_refreshed", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (!sessionStorage.getItem("page_refreshed")) {
        sessionStorage.removeItem("filter_param");
      }
    };
  }, []);

  return null;
}
